import { FC } from 'react';

import { IconContainer } from '../IconContainer';
import { IconProps } from '../types';

export const EmergencyServices20: FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className,
  style,
  svgClassName,
  svgStyle,
  ariaLabel,
  onClick,
}) => {
  return (
    <IconContainer
      size={size}
      className={className}
      style={style}
      ariaLabel={ariaLabel}
      onClick={onClick}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={svgClassName}
        style={svgStyle}
      >
        <path d="M11.9414 5.00316C12.0752 5.13867 12.1949 5.2858 12.2995 5.44222L13.5673 4.15852C13.8187 3.90393 13.8187 3.49116 13.5673 3.23656C13.3159 2.98197 12.9082 2.98197 12.6568 3.23657L11.3625 4.54705C11.5717 4.67317 11.7663 4.82593 11.9414 5.00316Z" fill={color} />
<path d="M6.11696 4.15852L7.38979 5.44733C7.49521 5.289 7.61606 5.14014 7.75134 5.00316C7.92489 4.82743 8.11775 4.67575 8.32488 4.55025L7.02749 3.23657C6.77605 2.98197 6.3684 2.98197 6.11696 3.23656C5.86553 3.49116 5.86553 3.90393 6.11696 4.15852Z" fill={color} />
<path d="M9.84635 4.12448C10.0696 4.12448 10.2902 4.14999 10.5045 4.19942V2.31867C10.5045 1.95862 10.2162 1.66675 9.86064 1.66675C9.50505 1.66675 9.2168 1.95862 9.2168 2.31867V4.19298C9.42207 4.14778 9.63302 4.12448 9.84635 4.12448Z" fill={color} />
<path fillRule="evenodd" clipRule="evenodd" d="M8.8361 5.68882C9.11392 5.40752 9.49072 5.24948 9.88361 5.24948C10.2765 5.24948 10.6533 5.40752 10.9311 5.68882C11.0801 5.83964 11.194 6.01928 11.2677 6.21479C13.3869 6.38031 14.4464 6.91675 14.4464 6.91675L15.4656 9.91675H16.6693V11.4167L15.9286 12.1667L15.9278 16.6667H14.4464C14.0376 16.6667 13.7057 16.3307 13.7057 15.9167H6.29874C6.29874 16.3307 5.9669 16.6667 5.55804 16.6667H4.07664V12.1667L3.33594 11.4167V9.91675H4.56031L5.55804 6.91675C5.55804 6.91675 6.53593 6.42166 8.49172 6.23598C8.56502 6.03226 8.68178 5.84508 8.8361 5.68882ZM13.7057 14.4167C13.2969 14.4167 12.965 14.0807 12.965 13.6667C12.965 13.2527 13.2969 12.9167 13.7057 12.9167C14.1146 12.9167 14.4464 13.2527 14.4464 13.6667C14.4464 14.0807 14.1146 14.4167 13.7057 14.4167ZM6.29874 14.4167C5.88987 14.4167 5.55804 14.0807 5.55804 13.6667C5.55804 13.2527 5.88987 12.9167 6.29874 12.9167C6.7076 12.9167 7.03944 13.2527 7.03944 13.6667C7.03944 14.0807 6.7076 14.4167 6.29874 14.4167ZM6.73427 8.0785C7.32905 7.903 8.42158 7.66675 10.0022 7.66675C11.591 7.66675 12.6865 7.90525 13.2746 8.07925L14.4087 11.4167H5.62396L6.73427 8.0785Z" fill={color} />
      </svg>
    </IconContainer>
  );
};
